import { type ComponentOptionsMixin, type Ref, type ComputedRef, isRef } from 'vue'
import ToastificationContent from '../components/toastification/ToastificationContent.vue'

type Stringable = string | (() => string)

type MaybeRef<T> = Ref<T> | ComputedRef<T> | T
type TextLike = MaybeRef<Stringable>
export type ToastType = 'warning' | 'danger' | 'success' | 'info'

export type ToastConfig = {
    title: TextLike,
    text: TextLike,
    icon?: string,
    variant?: ToastType
    draggable?: boolean
    timeout?: number
}
type ToastQuickConfig = { icon?: string, draggable?: boolean, timeout?: number }

export interface ToastMixin extends ComponentOptionsMixin {
    methods: {
        infoToast(
            title: TextLike,
            message: TextLike,
            params?: ToastQuickConfig
        ): void
        infoToast(title: TextLike, message: TextLike, icon?: string): void

        warnToast(
            title: TextLike,
            message: TextLike,
            params?: ToastQuickConfig
        ): void
        warnToast(title: TextLike, message: TextLike, icon?: string): void

        dangerToast(
            title: TextLike,
            message: TextLike,
            params?: ToastQuickConfig
        ): void
        dangerToast(title: TextLike, message: TextLike, icon?: string): void

        successToast(
            title: TextLike,
            message: TextLike,
            params?: ToastQuickConfig
        ): void
        successToast(title: TextLike, message: TextLike, icon?: string): void

        createToast(config: ToastConfig): void
    }
}

const unwrapText = (txt: TextLike): string => {
    let trgt: Stringable
    if (isRef(txt)) trgt = txt.value
    else trgt = txt
    if (typeof trgt === 'string') return trgt
    if (typeof trgt === 'function') return trgt()
    console.warn('Un valor no convertible ha sido pasado al toast', txt)
    return''
}

export default {
    methods: {
        successToast(title: TextLike, message: TextLike, params: ToastQuickConfig | string = 'BellIcon'): void {
            const options = typeof params === 'string' ? { icon: params } : params
            this.createToast({
                ... options,
                title,
                text: message,
                variant: 'success'
            })
        },

        infoToast(title: TextLike, message: TextLike, params: ToastQuickConfig | string = 'BellIcon'): void {
            const options = typeof params === 'string' ? { icon: params } : params
            this.createToast({
                ... options,
                title,
                text: message,
                variant: 'info'
            })
        },

        dangerToast(title: TextLike, message: TextLike, params: ToastQuickConfig | string = 'BellIcon'): void {
            const options = typeof params === 'string' ? { icon: params } : params
            this.createToast({
                ... options,
                title,
                text: message,
                variant: 'danger'
            })
        },

        warnToast(title: TextLike, message: TextLike, params: ToastQuickConfig | string = 'BellIcon'): void {
            const options = typeof params === 'string' ? { icon: params } : params
            this.createToast({
                ... options,
                title,
                text: message,
                variant: 'warning'
            })
        },

        createToast(config) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: unwrapText(config.title),
                    icon: config.icon,
                    text: unwrapText(config.text),
                    variant: config.variant,
                    timeout: config.timeout
                },
                timeout: config.timeout,
                draggable: config.draggable,

            })
        }

    }
} as ToastMixin
